export default __webpack_public_path__ + "static/media/Metrô Fill Orange.8710c041.svg";